import { render } from "./EmpresaConfig.vue?vue&type=template&id=563052a8&scoped=true"
import script from "./EmpresaConfig.vue?vue&type=script&lang=js"
export * from "./EmpresaConfig.vue?vue&type=script&lang=js"

import "./EmpresaConfig.vue?vue&type=style&index=0&id=563052a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563052a8"]])

export default __exports__